import { config } from "../../config";

import { EVChargerOutput, EVChargerStatus, EVChargerOutputStatus, EVChargerOutputPort, EVChargerOutputPortStatus, EVChargerType, EVChargerOutputType, EVChargerOutputPortType } from '@/entity/station/evcharger';
import { ValueRange } from '@/entity/value-range';
import { EVChargerOutputPortTransformer } from "../transformers/evcharger-ouput-port";


export class EVChargerTypeTransformer {
    transform(chargerTypeInfo: any) : EVChargerType {
        let outputTypesInfos: any[] = chargerTypeInfo.outputs
        let outputTypes: EVChargerOutputType[] = []
        outputTypesInfos.forEach(outputTypeInfo => {
            let portTypesInfos: any[] = outputTypeInfo.ports
            let portTypes: EVChargerOutputPortType[] = []
            portTypesInfos.forEach(portTypeInfo => {
                portTypes.push(new EVChargerOutputPortType(portTypeInfo.portType, portTypeInfo.description, config.api.host + "/common/static/images/" + portTypeInfo.portImage))
            });              
            outputTypes.push(
                new EVChargerOutputType(
                    outputTypeInfo.outputNumber,
                    outputTypeInfo.description,
                    outputTypeInfo.outputVolt,
                    outputTypeInfo.outputPhase,
                    new ValueRange(outputTypeInfo.outputKWStart, outputTypeInfo.outputKWEnd),
                    new ValueRange(outputTypeInfo.outputCurrentStart, outputTypeInfo.outputCurrentEnd),
                    portTypes,
                    outputTypeInfo.outputType
                )
            )
        })
        return new EVChargerType(
            chargerTypeInfo.chargerType,
            chargerTypeInfo.description,
            chargerTypeInfo.inputVoltage,
            chargerTypeInfo.inputPhase,
            chargerTypeInfo.chargerOutputType,
            outputTypes
        )
    }

    transformWithStatus(chargerTypeInfo: any, outputStatuses: EVChargerOutputStatus[], outputPortStatuses: EVChargerOutputPortStatus[]) : EVChargerType {
        let outputTypesInfos: any[] = chargerTypeInfo.outputs
        let outputTypes: EVChargerOutputType[] = []
        outputTypesInfos.forEach(outputTypeInfo => {
            let portTypesInfos: any[] = outputTypeInfo.ports
            let portTypes: EVChargerOutputPortType[] = []
            portTypesInfos.forEach(portTypeInfo => {
                portTypes.push(new EVChargerOutputPortType(portTypeInfo.portType, portTypeInfo.description, config.api.host + "/common/static/images/" + portTypeInfo.portImage, outputPortStatuses))
            });              
            outputTypes.push(
                new EVChargerOutputType(
                    outputTypeInfo.outputNumber,
                    outputTypeInfo.description,
                    outputTypeInfo.outputVolt,
                    outputTypeInfo.outputPhase,
                    new ValueRange(outputTypeInfo.outputKWStart, outputTypeInfo.outputKWEnd),
                    new ValueRange(outputTypeInfo.outputCurrentStart, outputTypeInfo.outputCurrentEnd),
                    portTypes,
                    outputTypeInfo.outputType,
                    outputStatuses
                )
            )
        })
        return new EVChargerType(
            chargerTypeInfo.chargerType,
            chargerTypeInfo.description,
            chargerTypeInfo.inputVoltage,
            chargerTypeInfo.inputPhase,
            chargerTypeInfo.chargerOutputType,
            outputTypes
        )
    }
}